/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OrderInfoForClientSkuReqVo,
  ResponseKoreaStockOutboundOrderStatisticsVo,
  ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVo,
  ResponsePageDataOrderInfoForClientSkuVo,
} from '../models/index';
import {
    OrderInfoForClientSkuReqVoFromJSON,
    OrderInfoForClientSkuReqVoToJSON,
    ResponseKoreaStockOutboundOrderStatisticsVoFromJSON,
    ResponseKoreaStockOutboundOrderStatisticsVoToJSON,
    ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVoFromJSON,
    ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVoToJSON,
    ResponsePageDataOrderInfoForClientSkuVoFromJSON,
    ResponsePageDataOrderInfoForClientSkuVoToJSON,
} from '../models/index';

export interface OrderBigTableStatisticsGetKoreaStockOutboundOrderSkuStatisticsInfoGetRequest {
    userId?: number;
    warehouseId?: number;
    startDate?: string;
    endDate?: string;
    skuCode?: string;
    marketBarcode?: string;
    orderCode?: string;
    receiverName?: string;
    ivc?: string;
    businessPlatformId?: number;
}

export interface OrderBigTableStatisticsGetKoreaStockOutboundOrderStatisticsGetRequest {
    userId: number;
}

export interface OrderBigTableStatisticsGetOrderInfoForClientSkuPutRequest {
    orderInfoForClientSkuReqVo?: OrderInfoForClientSkuReqVo;
}

/**
 * 
 */
export class OrderBigTableStatisticsControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 韩国库存出库订单 按sku维度 统计
     */
    async orderBigTableStatisticsGetKoreaStockOutboundOrderSkuStatisticsInfoGetRaw(requestParameters: OrderBigTableStatisticsGetKoreaStockOutboundOrderSkuStatisticsInfoGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVo>> {
        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        if (requestParameters['marketBarcode'] != null) {
            queryParameters['marketBarcode'] = requestParameters['marketBarcode'];
        }

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        if (requestParameters['receiverName'] != null) {
            queryParameters['receiverName'] = requestParameters['receiverName'];
        }

        if (requestParameters['ivc'] != null) {
            queryParameters['ivc'] = requestParameters['ivc'];
        }

        if (requestParameters['businessPlatformId'] != null) {
            queryParameters['businessPlatformId'] = requestParameters['businessPlatformId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTableStatistics/getKoreaStockOutboundOrderSkuStatisticsInfo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 韩国库存出库订单 按sku维度 统计
     */
    async orderBigTableStatisticsGetKoreaStockOutboundOrderSkuStatisticsInfoGet(requestParameters: OrderBigTableStatisticsGetKoreaStockOutboundOrderSkuStatisticsInfoGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVo> {
        const response = await this.orderBigTableStatisticsGetKoreaStockOutboundOrderSkuStatisticsInfoGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 韩国库存出库统计
     */
    async orderBigTableStatisticsGetKoreaStockOutboundOrderStatisticsGetRaw(requestParameters: OrderBigTableStatisticsGetKoreaStockOutboundOrderStatisticsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseKoreaStockOutboundOrderStatisticsVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling orderBigTableStatisticsGetKoreaStockOutboundOrderStatisticsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTableStatistics/getKoreaStockOutboundOrderStatistics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseKoreaStockOutboundOrderStatisticsVoFromJSON(jsonValue));
    }

    /**
     * 
     * 韩国库存出库统计
     */
    async orderBigTableStatisticsGetKoreaStockOutboundOrderStatisticsGet(requestParameters: OrderBigTableStatisticsGetKoreaStockOutboundOrderStatisticsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseKoreaStockOutboundOrderStatisticsVo> {
        const response = await this.orderBigTableStatisticsGetKoreaStockOutboundOrderStatisticsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取sku维度下的订单信息
     */
    async orderBigTableStatisticsGetOrderInfoForClientSkuPutRaw(requestParameters: OrderBigTableStatisticsGetOrderInfoForClientSkuPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataOrderInfoForClientSkuVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTableStatistics/getOrderInfoForClientSku`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrderInfoForClientSkuReqVoToJSON(requestParameters['orderInfoForClientSkuReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataOrderInfoForClientSkuVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取sku维度下的订单信息
     */
    async orderBigTableStatisticsGetOrderInfoForClientSkuPut(requestParameters: OrderBigTableStatisticsGetOrderInfoForClientSkuPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataOrderInfoForClientSkuVo> {
        const response = await this.orderBigTableStatisticsGetOrderInfoForClientSkuPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
